<template>
    <div>
        <div class="sub_title">
            메모
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>

                    <td class="c_t_title">메모</td>
                    <td>
                        <div>
                            <el-input type="textarea" v-model="memo" resize="none" @change="parentChange('memo', memo)"></el-input>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "ItemMemoLayout",
    mixins: [],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            memo: '',
            validatorArr: ['memo'],
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ItemMemoLayout');
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.memo = this.itemData.memo;
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            // this.$validate(['name', 'link', 'manageCode', 'price'])
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
